export default __webpack_public_path__ + "cocoa_floodlight_v2.618b5ddc.png";